<template>
  <div>
    <v-card tile flat>
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5 primary white--text">
            <h1 class="headline"> <strong>Instruksi</strong> Penilaian {{ fLabel }} dan Wawancara</h1>
            <p> Lakukan sesi tanya jawab dengan Kandidat, kemudian berikan nilai sesuai dengan rubrik yang tersedia </p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto container my-5" elevation="1">
      <v-toolbar flat style="height: auto">
        <v-toolbar-title>
          <div v-if="!isAsesor" class="font-weight-bold">
            Data {{ fLabel }} dan Wawancara Kandidat
            <span class="blue--text">
              {{ $getDeepObj(initValue, 'ptk.data.nama') }}
            </span>
          </div>
          <div v-else>
            <template v-if="$vuetify.breakpoint.mobile"> <br /><br /><br /> </template>
            <v-row>
              <v-col>
                <div class="caption"><v-icon left>mdi-account-check</v-icon> Peran Anda</div>
                <div class="blue--text font-weight-bold">Asesor {{ isAsesorUtama ? 'A' : 'B' }}</div>
              </v-col>
              <v-col>
                <div class="caption"><v-icon left>mdi-account-check</v-icon>Kandidat yang anda uji</div>
                <div class="black--text font-weight-bold">{{ $getDeepObj(initValue, 'ptk.data.nama') || '-' }}</div>
              </v-col>
            </v-row>
          </div>
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-divider class="my-3" />
      <v-card-text>
        <v-alert v-if="false" prominent color="deep-orange" border="left" outlined text>
          <div class="deep-orange--text font-weight-bold">Kandidat Terkendala</div>
          <div class="black--text body-2"
            >Kandidat ini sebelumnya sudah diset terkendala, Apabila Bapak/Ibu Asesor ingin menilai ulang dan dinyatakan
            <b>TIDAK TERKENDALA</b> maka pastikan Bapak/Ibu
            <b
              ><u>Mencabut atau <i>un-Check</i> "Ya saya Terkendala" pada Catatan Kendala di bawah</u></b
            ></div
          >
        </v-alert>
        <v-row v-if="isPreview ? tabAsesor === 0 : true" no-gutters class="pa-3 py-5 blue-grey lighten-5">
          <v-col cols="12" md="2" sm="12" class="d-inline-flex align-center justify-center">
            <v-icon size="80">mdi-google-hangouts</v-icon>
          </v-col>
          <v-col cols="12" md="10" sm="12" class="black--text">
            <h1>{{ isPreview ? 'Masuk' : 'Mulai' }} Sesi Pengujian Kandidat </h1>
            <p class="my-2">Yang perlu disiapkan untuk melakukan sesi simulasi Gmeet ini adalah</p>
            <ol class="my-3">
              <li>
                Pastikan Anda sudah masuk / login di akun belajar.id
              </li>
              <li>Klik Tautan "<b>Mulai Menguji Kandidat</b>"</li>
              <li>
                {{ isAsesorUtama ? 'Setelah ' : '' }}{{ isPreview ? 'Masuk' : 'Mulai' }} <b>GMeet</b>
                <template v-if="isAsesorUtama">
                  lakukan capture (screenshot) sebanyak 5x yaitu: 1x pada saat awal/perkenalan kandidat menunjukkan KTP,
                  2x saat pelaksanaan Simulasi Mengajar dan 2x saat pelaksanaan Wawancara
                </template>
              </li>
              <template v-if="isAsesorUtama">
                <li>Kemudian Bagikan / Share hasil capture sesuai panduan dan isikan tautannya pada hasil penilaian</li>
              </template>
            </ol>
            <template>
              <v-card
                class="blue darken-3"
                max-width="300"
                flat
                @click="onMeet"
                :disabled="!$getDeepObj(initValue, 'meta.url_meet')"
                style="cursor: pointer"
              >
                <v-list dense class="blue darken-3" dark>
                  <v-list-item two-line>
                    <v-list-item-avatar>
                      <v-icon x-large>mdi-google-hangouts</v-icon>
                    </v-list-item-avatar>
                    <div>
                      <v-list-item-subtitle>Tautan google meet</v-list-item-subtitle>
                      <h2>{{ isPreview ? 'Masuk' : 'Mulai' }} Menguji Kandidat</h2>
                    </div>
                  </v-list-item>
                </v-list>
              </v-card>

              <div v-if="!$getDeepObj(initValue, 'meta.url_meet')" class="my-2 red--text">
                <template v-if="isAsesorUtama">
                  Link google meet belum anda set, silakan cek di menu pengaturan jadwal saya
                </template>
                <template v-else>
                  Link google meet belum di set, silakan hubungi tim penilai utama
                </template>
              </div>
              <div class="mt-3">
                <v-btn color="indigo" depressed dark @click="$emit('info', initValue)" class="mr-1">
                  <v-icon left>mdi-alert-circle</v-icon>
                  Informasi Tambahan
                </v-btn>
              </div>
            </template>
          </v-col>
        </v-row>

        <v-alert class="my-5" colored-border border="left" color="blue" prominent>
          <div class="px-5">
            <h3>Bagaimana sesi simulasi yang sedang berjalan ?</h3>
            <p
              >Pilih salah satu tombol dibawah ini sesuai kondisi yang ada saat ini, karena akan berpengaruh terhadap
              penilaian kandidat</p
            >
          </div>
          <div class="my-2 px-5 text-center">
            <v-row>
              <template v-for="s in mSesiNilai">
                <v-col :key="s.value" cols="12" md="4" sm="12">
                  <v-card
                    outlined
                    :disabled="s.disable"
                    :dark="sesi === s.value"
                    :color="sesi === s.value ? itemColor : ''"
                    style="border-radius: 5pt"
                  >
                    <v-list-item @click="onSesi(s.value)">
                      <v-list-item-content>
                        <div>
                          <v-icon left large> {{ s.icon }} </v-icon>{{ s.text }}
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </div>
        </v-alert>
        <template v-if="sesi === 1">
          <v-card flat class="my-5">
            <v-row>
              <v-col cols="12" v-if="isPreview || !isAsesorUtama">
                <v-alert text prominent color="blue" border="left">
                  <v-container class="black--text">
                    <h3 class="blue--text">Persetujuan Nilai Rubrik</h3>
                    <v-checkbox :readonly="isPreview" v-model="simulasi.is_setuju_nilai" light>
                      <template v-slot:label>
                        <span> Saya setuju dengan penilaian <b>Asesor A</b> pada rubrik diatas</span>
                      </template>
                    </v-checkbox>

                    <v-divider class="my-2" />
                    <div class="ml-md-6">
                      <p>
                        <i class="grey--text"
                          >Jika Anda kurang setuju dengan penilaian yang ada pada rubrik, Anda dapat menghubungi Asesor
                          A untuk mendiskusikan nilai yang sesuai
                        </i>
                      </p>
                      <h4>Asesor A</h4>
                      <template v-if="$getDeepObj(initValue, 'psp_simulasi.akun_penilai.data.no_hp')">
                        {{ `+62${Number($getDeepObj(initValue, 'psp_simulasi.akun_penilai.data.no_hp'))}` }}
                        <v-icon
                          color="success"
                          small
                          dark
                          @click="onCall(Number($getDeepObj(initValue, 'psp_simulasi.akun_penilai.data.no_hp')))"
                        >
                          mdi-whatsapp
                        </v-icon>
                      </template>
                      <template v-else-if="$getDeepObj(initValue, 'psp_simulasi.akun_penilai.data.no_telpon')">
                        {{ `+62${Number($getDeepObj(initValue, 'psp_simulasi.akun_penilai.data.no_telpon'))}` }}
                      </template>
                      <template v-else>-</template>
                    </div>
                  </v-container>
                </v-alert>
              </v-col>
              <v-col cols="12" class="mx-3" v-if="!isPreview">
                <div class="pb-0 headline font-weight-medium"
                  >Masukan Tautan Hasil Capture Google Meet
                  <span v-if="!isAsesorUtama" class="red--text">*</span>
                </div>
                <ol>
                  <li>Buka email asesor</li>
                  <li>Buka aplikasi Google di kanan atas</li>
                  <li>Pilih icon aplikasi google drive</li>
                  <li>
                    Buat folder Dokumentasi Pelaksanaan SM & WW PSP 3 sesuai dengan format yang telah disampaikan saat
                    briefing
                  </li>
                  <li>Kemudian, pilih folder tanggal dan slot pelaksanaan SM & WW</li>
                  <li>Unggah 5 hasil tangkap layar sesuai dengan panduan</li>
                  <li>
                    Klik kanan dan pilih <b><i>share</i></b> atau <b>dapatkan link</b>
                  </li>
                  <li>Pastikan tautan yang Anda share dapat dilihat oleh siapa saja yang memiliki <i>link</i></li>
                  <li><i>Copy</i> dan <i>paste</i> tautan pada kolom di bawah</li>
                </ol>
                <v-text-field
                  class="mt-2"
                  :disabled="isPreview"
                  :readonly="!isAsesorUtama"
                  outlined
                  v-model="simulasi['url_rekaman']"
                  dense
                  hide-details
                  @click="onAlert('gmeet')"
                />

                <div v-if="!isAsesorUtama" class="mt-2 red--text">
                  *) Catatan : Yang <b>dapat menambahkan</b> tautan hasil capture google meet <b>hanya asesor inti</b>.
                </div>
                <div v-else class="mt-2 red--text">
                  *) Catatan : Anda <b>diwajibkan mengisi</b> tautan capture hasil SMWW.
                </div>
              </v-col>
              <v-col cols="12" v-else>
                <div class="pb-0 headline font-weight-medium">Tautan Recording</div>
                <a
                  v-if="$getDeepObj(initValue, 'psp_simulasi.url_rekaman')"
                  :href="$getDeepObj(initValue, 'psp_simulasi.url_rekaman')"
                  target="_blank"
                >
                  {{ $getDeepObj(initValue, 'psp_simulasi.url_rekaman') }}
                </a>
                <template v-if="$getDeepObj(initValue, 'psp_simulasi.url_rekaman')">
                  <div>
                    <iframe
                      class="my-2"
                      :src="$getDeepObj(initValue, 'psp_simulasi.url_rekaman').replace('view', 'preview')"
                      style="border: none; width: 100%; height: 350px"
                    />
                  </div>
                </template>
              </v-col>
              <v-col cols="12" v-if="isAsesor">
                <div class="pa-3">
                  <div class="pb-0 headline font-weight-medium"> Catatan Kandidat </div>
                  Silahkan berikan catatan terkait kandidat yang baru saja anda uji
                  <div class="pt-0">
                    <v-textarea
                      v-model="simulasi['catatan']"
                      placeholder="Berikan catatan kandidat ini"
                      class="mt-0"
                      hide-details
                      rows="3"
                      auto-grow
                      outlined
                      :readonly="isPreview"
                    />
                  </div>
                </div>
              </v-col>
              <v-col cols="12" v-else>
                <v-alert color="info" text>
                  <div class="deep-orange--text">* Catatan Asesor A</div>
                  <div class="black--text mx-md-3"> {{ $getDeepObj(initValue, 'psp_simulasi.catatan_penilai') }} </div>
                </v-alert>
                <v-alert color="info" text>
                  <div class="deep-orange--text">* Catatan Asesor B</div>
                  <div class="black--text mx-md-3">
                    {{ $getDeepObj(initValue, 'psp_simulasi.catatan_pendamping') }}
                  </div>
                </v-alert>
              </v-col>
            </v-row>
          </v-card>

          <div class="py-5">
            <h3>Pilih Kategori yang ingin anda nilai</h3>
            <p
              >Untuk urutan penilaian, Anda diharuskan untuk menilai kategori <b>{{ fLabel }}</b> terlebih dahulu
              kemudian tahap <b>Wawancara</b>
            </p>
            <v-row>
              <template v-for="s in mJenisPenilaian">
                <v-col :key="s.value" cols="12" md="6" sm="12">
                  <v-card
                    outlined
                    :dark="jenisNilai === s.value"
                    :color="jenisNilai === s.value ? 'blue' : ''"
                    style="border-radius: 5pt"
                  >
                    <v-list-item @click="onPenilaian(s.value)">
                      <v-list-item-content>
                        <div>
                          <v-row>
                            <v-col cols="12" sm="12" md="8">
                              <v-icon left large> {{ s.icon }} </v-icon>
                              <span class="title"> {{ s.text }}</span>
                            </v-col>
                            <v-col cols="12" sm="12" md="4" class="text-right justify-center">
                              <v-chip
                                v-if="isPreview && $getDeepObj(initValue, `kategori.${s.value}`)"
                                :color="$getDeepObj(initValue, `kategori.${s.value}.color`)"
                                dark
                              >
                                {{ 'Kategori ' + $getDeepObj(initValue, `kategori.${s.value}.text`) }}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-col>
              </template>
            </v-row>
          </div>

          <template v-if="jenisNilai">
            <v-alert text color="success">
              Selama melakukan simulasi tidak terjadi kendala yang mengganggu jalannya simulasi yang dilakukan aktor
              terkait, (Kandidat, Asesor A dan Asesor B).
            </v-alert>

            <v-row class="px-0 pb-5 pt-0">
              <v-col cols="12">
                <v-toolbar flat>
                  <v-toolbar-title class="headline black--text">Rubrik Penilaian</v-toolbar-title>
                  <v-spacer />
                  <v-btn v-if="fungsi === 'kasek'" color="purple" depressed dark class="mr-1" @click="onRpp">
                    <v-icon left>mdi-book</v-icon>
                    RPP Kandidat
                  </v-btn>
                  <v-btn v-if="false" color="blue" dark @click="$refs.panduanPenilaian.open()">
                    <v-icon left>mdi-alert-circle</v-icon>
                    PANDUAN PENILAIAN
                  </v-btn>
                </v-toolbar>
              </v-col>
              <v-col cols="12">
                <v-tabs v-model="menu">
                  <v-tab v-for="item in menus" :key="item.tab">
                    {{ item.tab }}
                  </v-tab>
                </v-tabs>
              </v-col>
            </v-row>
            <v-divider />
            <v-tabs-items v-model="menu">
              <v-tab-item v-for="menu in menus" :key="menu.tab">
                <template v-if="menu.content === 'penilaian'">
                  <template v-if="jenisNilai === 'simulasi'">
                    <template v-for="item in rubrik">
                      <div :key="item.key">
                        <div v-if="item.key === 'K3'" class="mt-5 pa-2 black--text">
                          <div class="body-1"><strong>Pertanyaan di Akhir Simulasi (Maksimal 6 menit)</strong></div>
                          <template v-if="fungsi === 'kasek'">
                            <ol>
                              <li
                                v-text="
                                  `Jelaskan apa yang menjadi kelemahan dan kelebihan dari pembelajaran yang baru saja dilakukan?`
                                "
                              />
                              <li
                                v-text="
                                  `Apa yang akan Bapak/Ibu lakukan secara berbeda jika mengajar topik/ pelajaran ini di kelas?`
                                "
                              />
                              <li>
                                <ol type="a">
                                  <li
                                    >Jelaskan jenis penilaian yg Bapak/Ibu rancang utk pembelajaran ini dan bagaimana
                                    Bapak/Ibu akan melaksanakan penilaian tersebut? Apa yang akan Bapak/Ibu lakukan
                                    terhadap hasil penilaian tersebut?</li
                                  >
                                  <li>Apa yang akan Bapak/Ibu lakukan terhadap hasil penilaian tersebut?</li>
                                </ol>
                              </li>
                            </ol>
                          </template>
                          <template v-else>
                            <ol>
                              <li
                                v-text="
                                  `Jelaskan apa yang menjadi kelemahan dan kelebihan pada kegiatan pelatihan yang baru saja dilakukan?`
                                "
                              />
                              <li
                                v-text="
                                  `Apa yang akan Bapak/Ibu lakukan secara berbeda jika menyampaikan topik ini di pelatihan yang sesungguhnya?`
                                "
                              />
                              <li>
                                <ol type="a">
                                  <li
                                    >Jelaskan strategi evaluasi yang Bpk/Ibu dapat rancang untuk memantau hasil dari
                                    pelatihan yang baru saja dilakukan?
                                  </li>
                                  <li>Bagaimana Bpk/Ibu menggunakan hasil evaluasi pelatihan tersebut?</li>
                                </ol>
                              </li>
                            </ol>
                          </template>
                        </div>
                        <v-card outlined class="mt-3">
                          <v-row>
                            <v-col cols="12" md="6">
                              <div class="pa-3">
                                <div class="blue--text body-1">
                                  <strong>{{ item.title }}</strong>
                                </div>
                                <div class="black--text">{{ item.label }}</div>
                                <div class="black--text pa-2">
                                  <ul>
                                    <li v-for="(list, l) in item.lists" :key="l"><span v-html="list" /> </li>
                                  </ul>
                                </div>
                              </div>
                            </v-col>
                            <v-col cols="12" md="6">
                              <div class="pa-3">
                                <v-row no-gutters dense>
                                  <v-col cols="12" v-for="(skor, i) in item.skorings" :key="skor.key">
                                    <div class="pa-2">
                                      <div
                                        ><strong>Penilaian {{ `${item.key}.${i + 1}` }}</strong></div
                                      >
                                      Berapa total kriteria yang terpenuhi berdasarkan jawaban kandidat ini?
                                    </div>
                                    <div class="radio-outline">
                                      <template v-for="s in skor.skors">
                                        <span class="ml-md-1" :key="s">
                                          <input
                                            type="radio"
                                            :id="`${skor.key}_${s}`"
                                            v-model="nilai_simulasi[skor.key]"
                                            :value="`${s}`"
                                            :disabled="isPreview || !isAsesorUtama"
                                            checked
                                          />
                                          <label :for="`${skor.key}_${s}`">{{ s }}</label>
                                        </span>
                                      </template>
                                      <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                          <v-icon
                                            class="ml-2"
                                            color="info"
                                            @click="onPanduanRubrik(skor.key, item.title, item.label)"
                                            v-on="on"
                                          >
                                            mdi-help-circle
                                          </v-icon>
                                        </template>
                                        <span>PANDUAN PENILAIAN</span>
                                      </v-tooltip>
                                    </div>
                                    <v-divider v-if="i === 0 && item.skorings.length > 1" />
                                  </v-col>
                                </v-row>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>
                      </div>
                    </template>
                  </template>
                  <template v-else-if="jenisNilai === 'wawancara'">
                    <v-card v-for="item in rubrikEsai" outlined class="mt-3" :key="item.key">
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="pa-3">
                            <div class="blue--text body-1">
                              <strong>{{ item.title }}</strong>
                            </div>
                            <div class="black--text my-2">
                              {{ item.label }}
                            </div>
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="pa-3">
                            <div><strong>Penilaian</strong></div>
                            Berapa total kriteria yang terpenuhi berdasarkan jawaban kandidat ini?
                          </div>
                          <div class="pa-3">
                            <div class="radio-outline">
                              <template v-for="skor in item.skoring">
                                <span class="ml-md-1" :key="skor">
                                  <input
                                    :disabled="isPreview || !isAsesorUtama"
                                    type="radio"
                                    :id="`${item.key}_${skor}`"
                                    v-model="nilai_wawancara[item.ww_id]"
                                    :value="`${skor}`"
                                    checked
                                  />
                                  <label :for="`${item.key}_${skor}`">{{ !skor ? 'NA' : skor }}</label>
                                </span>
                              </template>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    class="ml-2"
                                    color="info"
                                    @click="onPanduanRubrik(item.key, item.title, item.label)"
                                    v-on="on"
                                  >
                                    mdi-help-circle
                                  </v-icon>
                                </template>
                                <span>PANDUAN PENILAIAN</span>
                              </v-tooltip>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </template>
                </template>
                <template v-else>
                  <konten-penilaian
                    :isAsesor="isAsesor"
                    :initValue="initValue"
                    :kategori="menu.content"
                    :pertanyaans="pertanyaans"
                  />
                </template>
              </v-tab-item>
            </v-tabs-items>
          </template>
          <template v-else>
            <v-alert text color="orange">
              Harap memilih jenis penilaian.
            </v-alert>
          </template>
        </template>
        <template v-if="[2, 3].includes(sesi)">
          <v-row class="black--text">
            <v-col cols="12" md="6" sm="12">
              <v-img :src="$imgUrl('https://penggerak-cdn.siap.id/s3/gurupenggerak/gp-rubrik-ilust.png')" />
            </v-col>
            <v-col cols="12" md="6" sm="12">
              <h2 class="blue--text mb-2">{{ sesi === 2 ? 'Penjadwalan Kembali' : 'Diskualifikasi' }}</h2>
              Mohon Bapak/Ibu Tim Penilai (Asesor) untuk memperhatikan poin-poin di bawah ini sebelum memutuskan kepada
              kandidat apakah akan diberikan penjadwalan kembali atau tidak.
              <div v-if="sesi === 3">
                <b>Kandidat Diskualifikasi apabila :</b><br />
                <ol>
                  <li>Kandidat setelah dihubungi <b>Pemantau</b> menyatakan mengundurkan diri</li>
                  <li>Kandidat tidak mengetahu jadwal karena tidak peduli terhadap jadwal</li>
                  <li
                    >Kandidat tidak dapat dihubungi <b>Pemantau</b> sampai akhir sesi Gmeet {{ fLabel }} sampai jadwal
                    yang ditentukan.</li
                  >
                </ol>
              </div>
              <div v-else>
                <b>Kandidat Penjadwalan Kembali apabila :</b><br />
                <ol>
                  <li>Sambungan internet kandidat mengalami kendala teknis sehingga menggangu proses seleksi.</li>
                  <li
                    >Hal-hal yang menyebabkan seleksi harus dibatalkan (contoh : Musibah, orang tua meninggal, kandidat
                    sakit, perayaan keagamaan dst), setelah dihubungi <b>Pemantau</b></li
                  >
                  <li>Kandidat tidak memiliki akses informasi jadwal {{ fLabel }} dan Wawancara</li>
                  <li>Salah satu tim Asesor tidak hadir</li>
                </ol>
              </div>
            </v-col>
            <v-col cols="12" md="12" sm="12">
              <div>
                Apakah sesi {{ fLabel.toLowerCase() }} ini mengalami kandala ? (Koneksi Putus, Pemadaman Listrik atau
                kendala lain yang menghambat sesi {{ fLabel.toLowerCase() }} baik dari sisi kandidat maupun tim
                penilai). Tuliskan kendala tersebut pada kolom yang tersedia di bawah ini
                <br />
                <v-checkbox
                  :disabled="true"
                  height="5"
                  label="Ya saya mengalami kendala"
                  v-model="kendala"
                  color="success"
                />
                <div class="pt-0">
                  <v-textarea
                    v-model="simulasi['kendala']"
                    placeholder="Berikan catatan kandidat ini"
                    class="mt-0"
                    hide-details
                    rows="3"
                    auto-grow
                    outlined
                    :readonly="isPreview ? true : !isAsesorUtama"
                  />
                </div>
              </div>
              <div class="my-2 red--text">
                Apabila Anda dengan sengaja melaporkan kendala yang sebenarnya tidak terjadi
                <b>status Penilai Anda bisa dicabut dari Program Sekolah Penggerak</b>
              </div>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
    <panduan-wawancara
      ref="panduanPenilaian"
      :title="`Panduan Penilaian ${fLabel}`"
      penilaian="microteaching"
      :min="0"
      :max="4"
    />
    <popup-preview-detail ref="popup" :url="$getDeepObj(preview, 'url')" :title="$getDeepObj(preview, 'title')" />
    <panduan-esai
      ref="panduan"
      :title="fLabel"
      :min="jenisNilai === 'simulasi' ? 0 : 1"
      :labels="labelPanduan"
      :useNa="false"
    />
  </div>
</template>
<script>
import KontenPenilaian from '@views/instansi/penilaian/component/KontenPenilaian';
import PanduanEsai from '@views/instansi/penilaian/component/PanduanEsai';
import PanduanWawancara from '@views/instansi/penilaian/component/PanduanWawancara';
import PopupPreviewDetail from '@components/popup/PreviewDetil';
import mRubriks from '@views/instansi/penilaian/microteaching/rubriks';
import mEsai from '@views/instansi/penilaian/esai/configs';
import configsKasek from '@views/gtk/esai/configs/kasek';
import configsInstruktur from '@views/gtk/esai/configs/instruktur.js';
import configs from '@views/instansi/penilaian/esai/configs';
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    akun: {
      type: Object,
      default: () => {},
    },
    angkatan: {
      type: Number,
      default: 1,
    },
    isAsesor: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PanduanWawancara,
    PopupPreviewDetail,
    PanduanEsai,
    KontenPenilaian,
  },
  computed: {
    mSesiNilai() {
      return [
        {
          text: 'Penilaian Berhasil',
          value: 1,
          color: 'success',
          icon: 'mdi-account-check-outline',
          disable: false,
        },
        {
          text: 'Penjadwalan Kembali',
          value: 2,
          color: 'orange',
          icon: 'mdi-account-convert',
          disable: this.isPreview ? true : !this.isAsesorUtama,
        },
        {
          text: 'Kandidat Gagal',
          value: 3,
          color: 'red',
          icon: 'mdi-account-off-outline',
          disable: this.isPreview ? true : !this.isAsesorUtama,
        },
      ];
    },

    isAsesorUtama() {
      const asesor = this.$getDeepObj(this.initValue, 'psp_simulasi.penilai_id') || null;
      return asesor === this.$getDeepObj(this, 'akun.akun_id');
    },

    fungsi() {
      return Number(this.initValue?.k_profil_psp) === 1 ? 'instruktur' : 'kasek';
    },

    rubrik() {
      return mRubriks['rubrik'][this.fungsi][this.angkatan] || [];
    },

    rubrikEsai() {
      let rubriks = mEsai['rubriks'][this.fungsi][this.angkatan];
      rubriks.forEach((key, index) => {
        rubriks[index]['skoring'] = [1, 2, 3, 4, 5];
      });

      return rubriks;
    },

    tabsAsesor() {
      let temp = [];
      if (this.$getDeepObj(this, 'initValue.gpm_wawancara.akun_asesor')) {
        temp.push({
          tab: 0,
          asesor: 'Asesor A:' + this.$getDeepObj(this, 'initValue.gpm_simulasi_ajar.akun_asesor.nama'),
        });
      }

      if (this.$getDeepObj(this, 'initValue.gpm_wawancara.akun_asesor_bantu')) {
        temp.push({
          tab: 1,
          asesor: 'Asesor B:' + this.$getDeepObj(this, 'initValue.gpm_simulasi_ajar.akun_asesor_bantu.nama'),
        });
      }

      return temp;
    },

    kategoris() {
      return {
        1: { text: 'Kategori A', color: 'success' },
        2: { text: 'Kategori B', color: 'orange' },
        3: { text: 'Kategori C', color: 'red' },
      };
    },

    isTerkendala() {
      if (this.isPreview) return false;
      return (
        Number(
          this.$getDeepObj(
            this,
            `initValue.gpm_simulasi_ajar.${this.isAsesorUtama ? 'is_kendala' : 'is_kendala_bantu'}`
          )
        ) === 1
      );
    },

    itemColor() {
      const mColorSesi = {
        1: 'success',
        2: 'orange',
        3: 'red',
      };

      return mColorSesi[this.sesi];
    },

    labelPanduan() {
      return ['Lemah', 'Berkembang', 'Layak', 'Cakap', 'Mahir'];
    },

    pertanyaans() {
      const model = this.configsEsai[this.fungsi] || [];
      return (model && model['header'] && model['header'][1]) || [];
    },

    menus() {
      let temp = [{ tab: 'Rubrik Penilaian', content: 'penilaian' }];

      if (this.jenisNilai === 'simulasi' && this.fungsi === 'instruktur') {
        temp.push({ tab: 'Lihat SAP', content: 'sap', badge: true });
      }

      if (this.jenisNilai === 'wawancara') {
        temp.push({ tab: 'Lihat CV', content: 'cv' });
        temp.push({ tab: 'Lihat Esai', content: 'esai', badge: true });
      }
      return temp;
    },

    fLabel() {
      return this.fungsi === 'kasek' ? 'Simulasi Mengajar' : 'Simulasi Melatih';
    },

    mJenisPenilaian() {
      return [
        {
          text: this.fLabel || 'Simulasi Mengajar',
          value: 'simulasi',
          color: 'blue',
          icon: 'mdi-teach',
        },
        {
          text: 'Wawancara',
          value: 'wawancara',
          color: 'blue',
          icon: 'mdi-google-hangouts',
        },
      ];
    },
  },
  data() {
    return {
      form: {},
      tab: null,
      kendala: false,
      tabs: [
        { tab: 'Catatan Kandidat', content: 'catatan', desc: 'Berikan Catata Pada Kandidat ini' },
        { tab: 'Catatan Kendala', content: 'kendala', desc: 'Berikan Caatan Kendala' },
      ],
      tabAsesor: 0,
      preview: {},
      menu: null,
      sesi: null,
      jenisNilai: null,
      configsEsai: {
        kasek: configsKasek,
        instruktur: configsInstruktur,
      },
      simulasi: {},
      nilai_simulasi: {},
      nilai_wawancara: {},
    };
  },

  methods: {
    reset() {
      this.$set(this, 'simulasi', {});
      this.$set(this, 'nilai_simulasi', {});
      this.$set(this, 'nilai_wawancara', {});
      this.$set(this, 'kendala', 0);
      this.$set(this, 'sesi', null);
      this.$set(this, 'jeniNilai', null);
    },

    resetTab() {
      this.$set(this, 'tabAsesor', 0);
      this.$set(this, 'tab', 0);
    },

    getValue() {
      return {
        simulasi: this.simulasi,
        isAsesorUtama: this.isAsesorUtama,
        nilai_simulasi: this.nilai_simulasi,
        nilai_wawancara: this.nilai_wawancara,
        sesi: this.sesi,
      };
    },

    initForm(value) {
      const psp_simulasi = value?.psp_simulasi || {};
      const rubriks = value?.psp_profil_nilais?.data || [];
      let keys = {
        kasek: {
          simulasi: ['71', '72', '73', '74', '75', '76'],
          wawancara: ['81', '82', '83', '84', '85', '86', '87', '88', '89', '90'],
        },
        instruktur: {
          simulasi: ['271', '272', '273', '274', '275', '276'],
          wawancara: ['281', '282', '283', '284', '285', '286', '287', '288'],
        },
      };

      Object.keys(keys[this.fungsi]).forEach((key) => {
        keys[this.fungsi][key].forEach((item) => {
          const find = rubriks.find((s) => s.k_profil_rubrik_psp === Number(item)) || {};
          this.$set(
            this[`nilai_${key}`],
            item,
            ([null, '', undefined].includes(find['nilai']) ? '' : find['nilai']).toString()
          );
        });
      });

      if (this.$getDeepObj(value, 'psp_simulasi.kendala_penilai')) {
        this.$set(this, 'kendala', 1);
        this.$set(this, 'sesi', Number(value.psp_simulasi.is_ulang) === 1 ? 2 : 3);
        this.$set(this.simulasi, 'is_ulang', value.psp_simulasi.is_ulang);
        this.$set(this.simulasi, 'kendala', this.$getDeepObj(value, 'psp_simulasi.kendala_penilai'));
      } else {
        if (Number(value && value.k_proses_simulasi_psp) >= 5) {
          this.$set(this, 'sesi', 1);
          this.$set(this, 'jenisNilai', 'simulasi');
        }
        if (Number(value && value.k_proses_simulasi_psp) === 6) {
          this.$set(this.simulasi, 'is_setuju_nilai', 1);
        }
      }

      this.$set(
        this.simulasi,
        'catatan',
        this.$getDeepObj(psp_simulasi, `${this.isAsesorUtama ? 'catatan_penilai' : 'catatan_pendamping'}`) || ''
      );
      this.$set(this.simulasi, 'url_rekaman', this.$getDeepObj(psp_simulasi, 'url_rekaman') || '');
    },

    onMeet() {
      window.open(this.$getDeepObj(this.initValue, 'meta.url_meet'), '_blank');
    },

    onChangeTab(value) {
      this.reset();
      this.initForm(this.initValue, value);
    },

    onRpp() {
      const url = this.$getDeepObj(this, 'initValue.psp_profil_rpps.data.0.url_rpp') || '';

      if (!url) {
        this.$error('Kandidat Belum unggah RPP');
        return;
      }

      window.open(url, '_blank');

      // this.$set(this.preview, 'url', this.$getDeepObj(this, 'initValue.gpm_guru_rpps.0.url_file'))
      // this.$set(this.preview, 'title', this.$getDeepObj(this, 'initValue.gpm_guru_rpps.0.judul'))
      //
      // this.$nextTick(() => {
      //   this.$refs.popup.open()
      // })
    },

    onPanduanRubrik(id, label, desc) {
      const mSimulasi = this.$getDeepObj(mRubriks.panduan, `${this.fungsi}.${this.angkatan}`);
      const mWawancara = this.$getDeepObj(configs.panduan, `${this.fungsi}.${this.angkatan}`);
      const model = this.jenisNilai === 'simulasi' ? mSimulasi : mWawancara;
      let panduan = {};
      Object.keys(model[id]).forEach((index) => {
        this.$set(panduan, index === 'NA' ? 'NA' : index - 1, model[id][index]);
      });

      const data = {
        label: label,
        desc: desc,
        esais: panduan,
      };

      this.$refs.panduan.open('rubriks', data);
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(item)}`;
      window.open(url, '_blank');
    },

    onAlert(aksi) {
      switch (aksi) {
        case 'gmeet':
          if (!this.isAsesorUtama) {
            this.$info(`Yang dapat mengisikan capture ${this.fLabel.toLowerCase()} hanya asesor A`);
          }
      }
    },

    onSesi(value) {
      this.sesi = value;
      switch (value) {
        case 1:
          this.$set(this, 'kendala', null);
          break;
        case 2:
          this.$set(this, 'kendala', 1);
          this.$set(this.simulasi, 'is_ulang', 1);
          break;
        case 3:
          this.$set(this, 'kendala', 1);
          this.$set(this.simulasi, 'is_ulang', 0);
          break;
      }
    },

    onPenilaian(value) {
      this.jenisNilai = value;
    },

    onShowEsai(number) {
      this.showEsai = number - 1;
      document.getElementsByClassName('v-dialog--active')[0].scrollTop = 250;
    },
  },
  watch: {
    initValue: 'initForm',
    tabAsesor: 'onChangeTab',
    kendala: function(value) {
      if (Number(value) === 0) {
        this.$set(this.simulasi, 'kendala', '');
      }
    },
    isTerkendala: function(value) {
      if (value) {
        this.sesi = this.simulasi && this.simulasi.is_ulang === 1 ? 2 : 3;
      }
    },
  },
};
</script>
